import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { postRequest } from "../../../constants/api";
import { Loader, SearchBar } from "../../../components";
import { ShowTableTampilBidAngsuranKelompok } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Colors } from "../../../constants/styles";
import { formatDate } from "../../../constants/helper";
import {
  Box,
  Paper,
  Alert,
  Button,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Autocomplete,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahPenetapanPemenang = () => {
  const screenSize = useScreenWidth();
  const [isFetchError, setIsFetchError] = useState(false);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);

  // Angsuran
  const [lelangBulananId, setLelangBulananId] = useState("");
  const [angsuranKelompokId, setAngsuranKelompokId] = useState("");
  const [pesertaKelompokId, setPesertaKelompokId] = useState("");
  const [namaPeserta, setNamaPeserta] = useState("");
  const [no, setNo] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [tglPenetapanPemenang, setTglPenetapanPemenang] = useState(new Date());
  const [nominalLelang, setNominalLelang] = useState("");
  const [nominal, setNominal] = useState("");
  const [angPerBulan, setAngPerBulan] = useState(0);

  const [kelompoks, setKelompoks] = useState([]);

  const [kelompokId, setKelompokId] = useState("");
  const [noKelompok, setNoKelompok] = useState("");

  // Jaminan Peserta
  const [jenisJaminan, setJenisJaminan] = useState("");
  const [nomorJaminan, setNomorJaminan] = useState("");
  const [nilaiJaminan, setNilaiJaminan] = useState("");

  const [bidAngsuranKelompoks, setBidAngsuranKelompoks] = useState([]);

  const [openKelompok, setOpenKelompok] = useState(false);
  const [searchTermKelompok, setSearchTermKelompok] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [angsuranKelompoks, setAngsuranKelompoks] = useState([]);
  const [openAngsuranKelompok, setOpenAngsuranKelompok] = useState(false);
  const [searchTermAngsuranKelompok, setSearchTermAngsuranKelompok] =
    useState("");
  let [pageAngsuranKelompok, setPageAngsuranKelompok] = useState(0);
  const [limitAngsuranKelompok, setLimitAngsuranKelompok] = useState(1000);
  const [pagesAngsuranKelompok, setPagesAngsuranKelompok] = useState(0);
  const [rowsAngsuranKelompok, setRowsAngsuranKelompok] = useState(0);
  const [queryAngsuranKelompok, setQueryAngsuranKelompok] = useState("");

  const [pesertaKelompoks, setPesertaKelompoks] = useState([]);
  const [openPesertaKelompok, setOpenPesertaKelompok] = useState(false);
  const [searchTermPesertaKelompok, setSearchTermPesertaKelompok] =
    useState("");
  let [pagePesertaKelompok, setPagePesertaKelompok] = useState(0);
  const [limitPesertaKelompok, setLimitPesertaKelompok] = useState(1000);
  const [pagesPesertaKelompok, setPagesPesertaKelompok] = useState(0);
  const [rowsPesertaKelompok, setRowsPesertaKelompok] = useState(0);
  const [queryPesertaKelompok, setQueryPesertaKelompok] = useState("");

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermKelompok(query);
  };

  const handleClickOpenKelompok = () => {
    setOpenKelompok(true);
  };

  const handleCloseKelompok = () => {
    setOpenKelompok(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangeAngsuranKelompok = (e, p) => {
    setPageAngsuranKelompok(p - 1);
  };

  const searchDataAngsuranKelompok = (e) => {
    e.preventDefault();
    setPageAngsuranKelompok(0);
    setSearchTermAngsuranKelompok(query);
  };

  const handleClickOpenAngsuranKelompok = () => {
    setOpenAngsuranKelompok(true);
  };

  const handleCloseAngsuranKelompok = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAngsuranKelompok(false);
  };

  const handleChangePesertaKelompok = (e, p) => {
    setPagePesertaKelompok(p - 1);
  };

  const searchDataPesertaKelompok = (e) => {
    e.preventDefault();
    setPagePesertaKelompok(0);
    setSearchTermPesertaKelompok(query);
  };

  const handleClickOpenPesertaKelompok = () => {
    setOpenPesertaKelompok(true);
  };

  const handleClosePesertaKelompok = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenPesertaKelompok(false);
  };

  let jenisJaminanOptions = [
    {
      label: "SERTIFIKAT",
    },
    {
      label: "BPKB",
    },
  ];

  useEffect(() => {
    getKelompoksFirstTime();
  }, []);

  useEffect(() => {
    getKelompoks();
  }, [page, searchTermKelompok]);

  useEffect(() => {
    if (kelompokId !== "") {
      getAngsuranKelompoksByKelompok();
    }
  }, [kelompokId, pageAngsuranKelompok, searchTermAngsuranKelompok]);

  useEffect(() => {
    if (angsuranKelompokId !== "") {
      getBidsByAngsuranKelompok();
    }
  }, [angsuranKelompokId]);

  useEffect(() => {
    if (kelompokId !== "" && lelangBulananId !== "") {
      getPesertaKelompoksByKelompok();
    }
  }, [
    kelompokId,
    lelangBulananId,
    pagePesertaKelompok,
    searchTermPesertaKelompok,
  ]);

  const getKelompoks = async () => {
    const response = await postRequest(
      `/kelompoksBelumLunasPagination?search_query=${searchTermKelompok}&page=${page}&limit=${limit}`,
      {},
      navigate,
      dispatch,
    );
    setQuery(searchTermKelompok);
    setKelompoks(response.data.kelompoks);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getKelompoksFirstTime = async () => {
    const response = await postRequest(
      `/kelompoksBelumLunasPagination?search_query=${searchTermKelompok}&page=${page}&limit=${limit}`,
      {},
      navigate,
      dispatch,
    );
    setQuery(searchTermKelompok);
    setKelompoks(response.data.kelompoks);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getAngsuranKelompoksByKelompok = async () => {
    const response = await postRequest(
      `/lelangBulanansAktifPaginationByKelompok?search_query=${searchTermAngsuranKelompok}&page=${pageAngsuranKelompok}&limit=${limitAngsuranKelompok}`,
      {
        kelompokId,
        pesertaId: user.pesertaId,
      },
      navigate,
      dispatch,
    );
    setQueryAngsuranKelompok(searchTermAngsuranKelompok);
    setAngsuranKelompoks(response.data.lelangBulanans);
    setPageAngsuranKelompok(response.data.page);
    setPagesAngsuranKelompok(response.data.totalPage);
    setRowsAngsuranKelompok(response.data.totalRows);
  };

  const getBidsByAngsuranKelompok = async () => {
    const response = await postRequest(
      `/bidsByAngsuranKelompok`,
      {
        angsuranKelompokId,
      },
      navigate,
      dispatch,
    );
    setBidAngsuranKelompoks(response.data);
  };

  const getPesertaKelompoksByKelompok = async () => {
    const response = await postRequest(
      `/pesertaKelompoksBlmMenangByKelompokForPenetapanPemenangPagination?search_query=${searchTermAngsuranKelompok}&page=${pageAngsuranKelompok}&limit=${limitAngsuranKelompok}`,
      {
        kelompokId,
        lelangBulananId,
      },
      navigate,
      dispatch,
    );
    setQueryPesertaKelompok(searchTermPesertaKelompok);
    setPesertaKelompoks(response.data.pesertaKelompoks);
    setPagePesertaKelompok(response.data.page);
    setPagesPesertaKelompok(response.data.totalPage);
    setRowsPesertaKelompok(response.data.totalRows);

    if (response.data.pesertaKelompoks) {
      setPesertaKelompokId(response.data.pesertaKelompoks[0].id);
      setNamaPeserta(response.data.pesertaKelompoks[0].peserta.namaPeserta);

      let tempNominal =
        nominalLelang -
        response.data.pesertaKelompoks[0].nominalBid -
        angPerBulan;
      setNominal(tempNominal);
    }
  };

  const savePenetapanPemenang = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);

        const response = await postRequest(
          `/savePenetapanPemenang`,
          {
            lelangBulananId,
            angsuranKelompokId,
            pesertaKelompokId,
            kelompokId,
            pesertaId: user.pesertaId,
            no,
            tglPenetapanPemenang,
            nominal,

            // Jaminan Peserta
            jenisJaminan,
            nomorJaminan,
            nilaiJaminan,
          },
          navigate,
          dispatch,
        );
        setLoading(false);
        navigate("/penetapanPemenang");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Lelang</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Penetapan Pemenang</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={savePenetapanPemenang}>
        <Card>
          <Card.Header>Penetapan Pemenang</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        No. Kelompok <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          required
                          value={noKelompok}
                          readOnly
                          placeholder="Pilih..."
                          onClick={() => handleClickOpenKelompok()}
                          isInvalid={noKelompok.length === 0 && true}
                        />
                        <Form.Control.Feedback type="invalid">
                          No. Kelompok harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        No. Angsuran <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          required
                          value={no}
                          readOnly
                          placeholder="Pilih..."
                          onClick={() => handleClickOpenAngsuranKelompok()}
                          isInvalid={no.length === 0 && true}
                        />
                        <Form.Control.Feedback type="invalid">
                          No. Angsuran harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Tgl. Jatuh Tempo :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control disabled value={tglJatuhTempo} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Peserta <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          required
                          value={namaPeserta}
                          readOnly
                          placeholder="Pilih..."
                          onClick={() => handleClickOpenPesertaKelompok()}
                          isInvalid={namaPeserta.length === 0 && true}
                        />
                        <Form.Control.Feedback type="invalid">
                          Peserta harus diisi!
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Tgl. Penetapan Pemenang :
                      </Form.Label>
                      <Col sm="6">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control required />}
                          selected={tglPenetapanPemenang}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Nominal <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="6">
                        <NumericFormat
                          required
                          value={nominal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setNominal(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Jenis Jaminan :
                      </Form.Label>
                      <Col sm="8">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={jenisJaminanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          value={jenisJaminan}
                          onChange={(e, value) => {
                            if (value) {
                              setJenisJaminan(value.label);
                            } else {
                              setJenisJaminan("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nomor Jaminan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={nomorJaminan}
                          onChange={(e) => {
                            setNomorJaminan(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nilai Jaminan :
                      </Form.Label>
                      <Col sm="8">
                        <NumericFormat
                          value={nilaiJaminan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setNilaiJaminan(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Bid Peserta</Card.Header>
          <Card.Body>
            <Box sx={tableContainer}>
              <ShowTableTampilBidAngsuranKelompok
                currentPosts={bidAngsuranKelompoks}
              />
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/penetapanPemenang")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openKelompok}
        onClose={handleCloseKelompok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Kelompok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No. Kelompok
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Tgl.</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {kelompoks.map((user, index) => (
                    <TableRow
                      key={user._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setNoKelompok(user.noKelompok);
                        setKelompokId(user.id);

                        handleCloseKelompok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {user.noKelompok}
                      </TableCell>
                      <TableCell>{formatDate(user.tglKelompok)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAngsuranKelompok}
        onClose={handleCloseAngsuranKelompok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Angsuran Kelompok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataAngsuranKelompok}>
              <Box sx={searchBarContainer}>
                <SearchBar
                  value={queryAngsuranKelompok}
                  setSearchTerm={setQueryAngsuranKelompok}
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No.
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Tgl. Jatuh Tempo
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {angsuranKelompoks.map((user, index) => (
                    <TableRow
                      key={user._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setLelangBulananId(user.id);
                        setAngsuranKelompokId(user.angsurankelompok.id);
                        setNo(user.angsurankelompok.no);
                        setTglJatuhTempo(
                          formatDate(user.angsurankelompok.tglJatuhTempo),
                        );
                        setNominalLelang(user.nominal);
                        setAngPerBulan(user.angsurankelompok.angPerBulan);

                        handleCloseAngsuranKelompok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {user.angsurankelompok.no}
                      </TableCell>
                      <TableCell>
                        {formatDate(user.angsurankelompok.tglJatuhTempo)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesAngsuranKelompok}
                page={pageAngsuranKelompok + 1}
                onChange={handleChangeAngsuranKelompok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openPesertaKelompok}
        onClose={handleClosePesertaKelompok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Peserta`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataPesertaKelompok}>
              <Box sx={searchBarContainer}>
                <SearchBar
                  value={queryPesertaKelompok}
                  setSearchTerm={setQueryPesertaKelompok}
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No.
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    {/* <TableCell sx={{ fontWeight: "bold" }}>Bid</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pesertaKelompoks.map((user, index) => (
                    <TableRow
                      key={user._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setPesertaKelompokId(user.id);
                        setNamaPeserta(user.peserta.namaPeserta);

                        handleClosePesertaKelompok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {user.peserta.namaPeserta}
                      </TableCell>
                      {/* <TableCell>
                        {user.nominalBid.toLocaleString("en-US")}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesPesertaKelompok}
                page={pagePesertaKelompok + 1}
                onChange={handleChangePesertaKelompok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahPenetapanPemenang;

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
